/**
 * Конвертер времени из иникстайма в человечское,
 * вторым параметром передаем настройку для длины месяца
 */

export default function parseUnixTime(UNIX_timestamp, $format = 'full', div = '-'){
  var time = new Date(UNIX_timestamp * 1000),
  numbers = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
  months = {
    short: ['Янв','Фев','Мар','Апр','Май','Июн','Июл','Авг','Сент','Окт','Ноя','Дек'],
    full: ['Января','Февраля','Марта','Апреля','Мая','Июня','Июля','Августа','Сентября','Октября','Ноября','Декабря',],
    date: numbers,
    dateVs: numbers,
    dateTimeVs: numbers,
    dateTimeSOAP: numbers,
    humanDate: numbers,
    timeOnly: numbers,
  }

  var year = time.getFullYear();
  var month = months[$format][time.getMonth()];
  var day = (time.getDate() < 10) ? '0' + time.getDate() : time.getDate();
  var hour = time.getHours()< 10 ? '0' + time.getHours() : time.getHours();
  var min = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes();
  var sec = time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds();
  // var time = day + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec
var dates = {
    short: day + div + month + div + year,
    full: day + div + month + div + year,
    date: year + div + month + div + day,
    dateVs: day + div + month + div + year,
    dateTimeVs: day + div + month + div + year+' ' + hour + ':' + min + ':' + sec,
    dateTimeSOAP: year + div + month + div + day+'T' + hour + ':' + min + ':' + sec,
    humanDate: day + div + month + div + (year+'').substr(2, 2),
    timeOnly: hour + ':' + min + ':' + sec,
  }
  return dates[$format]
}



/** WEBPACK FOOTER **
 ** ./src/js/lib/parseUnixTime.js
 **/